module.exports = __webpack_public_path__ + "img/BentonSansBBVA-Bold.42e7524d.svg";